import { render, staticRenderFns } from "./share-modal.vue?vue&type=template&id=7fbd70ec&"
import script from "./share-modal.vue?vue&type=script&lang=js&"
export * from "./share-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports